import { createPopper } from '@popperjs/core';
import * as bootstrap from 'bootstrap';

import Swiper from 'swiper';
import  { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

Swiper.use([Autoplay, EffectFade, Navigation, Pagination])


const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

document.addEventListener('DOMContentLoaded', function () {
    const scrollOffset = 24; // Change this value to set the scroll threshold
    const body = document.body;

    window.addEventListener('scroll', function () {
        if (window.scrollY > scrollOffset) {
            body.classList.add('scroll-offset');
        } else {
            body.classList.remove('scroll-offset');
        }
    });
});


const heroSwiper = new Swiper('.masthead-home .swiper', {
    loop: true,
    spaceBetween: 0,
    effect: 'fade',
    speed: 1000,
    fadeEffect: {
        crossFade: true,
    },
    autoplay: {
        delay: 4500,
    },
});


const bannerSwiper = new Swiper('.swiper-banner .swiper', {
    loop: true,
    spaceBetween: 0,
    effect: 'fade',
    speed: 1000,
    fadeEffect: {
        crossFade: true,
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    autoplay: {
        delay: 4500,
    },
});

const solutionSwiper = new Swiper('.solution-slider', {
    slidesPerView: 1.15,
    spaceBetween: 30,
    breakpoints: {
        500: {
            slidesPerView: 1.75,
            spaceBetween: 24,
        },
        768: {
            slidesPerView: 2.25,
            spaceBetween: 24,
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 24,
        },
        1200: {
            slidesPerView: 4,
            spaceBetween: 24,
        },
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});
